module.exports = __webpack_public_path__ + "media/images/redesign-images/graduate-program/tcby-02-8c47bbccc67a55900f9d4110ededfb5b.webp";